import React from 'react';
import { Gift, Copy, MessageSquareReply, RotateCcw, Check } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
const bonusItems = [{
  icon: Copy,
  text: '50 mensajes listos para copiar y pegar',
  detail: 'Solo elige, copia y envía. Sin pensar de más.'
}, {
  icon: MessageSquareReply,
  text: 'Respuestas para cuando te deja en "visto"',
  detail: 'Frases probadas que hacen que responda.'
}, {
  icon: RotateCcw,
  text: 'Frases para reactivar chats muertos',
  detail: 'Revive conversaciones que parecían perdidas.'
}];
export function BonusSection() {
  return <section className="py-14 px-6 relative overflow-hidden bg-[#161616]" data-id="element-14">
      {/* Subtle background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-amber-500/5 rounded-full blur-[120px] pointer-events-none" data-id="element-15" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-16">
        <FadeIn data-id="element-17">
          <div className="text-center mb-4" data-id="element-18">
            <motion.div initial={{
            rotate: -5,
            scale: 0.9
          }} whileInView={{
            rotate: 0,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-amber-500/15 border border-amber-500/30 text-amber-400 text-sm font-bold mb-4" data-id="element-19">
              <Gift className="w-5 h-5" data-id="element-20" />
              BONUS GRATIS CON TU COMPRA
            </motion.div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-3" data-id="element-21">
              Espera…{' '}
              <span className="text-amber-400 italic" data-id="element-22">
                ¡no compres sin esto!
              </span>
            </h2>
            <p className="text-brand-lightGray text-lg max-w-2xl mx-auto" data-id="element-23">
              Por la compra de{' '}
              <strong className="text-brand-cream" data-id="element-24">
                "Nunca Más Te Dejan en Visto"
              </strong>
              , te llevas este bono completamente{' '}
              <span className="text-amber-400 font-bold" data-id="element-25">GRATIS</span>:
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8 items-center mt-8" data-id="element-26">
          {/* Bonus Image */}
          <FadeIn direction="left" data-id="element-27">
            <div className="relative flex justify-center" data-id="element-28">
              <div className="absolute inset-0 bg-rose-500/10 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-29" />
              <img src="https://cdn.magicpatterns.com/uploads/wpFEkxicUk1UhyRdBMoevM/ChatGPT_Image_29_mar_2026,_06_43_55_p.m..png" alt="Bonus: 50 Mensajes Listos para Copiar y Pegar" className="relative z-10 w-full max-w-sm rounded-2xl shadow-2xl shadow-rose-500/15 border border-white/10" data-id="element-30" />
            </div>
          </FadeIn>

          {/* Bonus Details */}
          <FadeIn direction="right" data-id="element-31">
            <div className="bg-brand-gray/30 border border-amber-500/15 rounded-3xl p-6 md:p-8 relative overflow-hidden" data-id="element-32">
              {/* Top accent */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-500 to-amber-400" data-id="element-33" />

              <div className="flex items-center gap-3 mb-4" data-id="element-34">
                <span className="text-3xl" data-id="element-35">🎁</span>
                <div data-id="element-36">
                  <p className="text-xs text-amber-400 font-bold uppercase tracking-wider" data-id="element-37">
                    Bono Exclusivo
                  </p>
                  <h3 className="font-serif text-xl font-bold text-brand-cream" data-id="element-38">
                    50 Mensajes Listos para Copiar y Pegar
                  </h3>
                </div>
              </div>

              <p className="text-brand-lightGray mb-6 text-sm" data-id="element-39">
                Mensajes probados que hacen que él responda, se interese… y
                vuelva. Solo copia, pega y observa cómo cambia todo.
              </p>

              <div className="space-y-3 mb-6" data-id="element-40">
                {bonusItems.map((item, index) => <div key={index} className="flex items-start gap-3 p-3 rounded-xl bg-white/5 border border-white/5" data-id="element-41">
                    <div className="w-9 h-9 rounded-lg bg-amber-500/15 flex items-center justify-center shrink-0" data-id="element-42">
                      <item.icon className="w-4 h-4 text-amber-400" data-id="element-43" />
                    </div>
                    <div data-id="element-44">
                      <p className="text-brand-cream font-medium text-sm" data-id="element-45">
                        {item.text}
                      </p>
                      <p className="text-brand-lightGray text-xs mt-0.5" data-id="element-46">
                        {item.detail}
                      </p>
                    </div>
                  </div>)}
              </div>

              {/* Value callout */}
              <div className="flex items-center justify-between p-3 bg-brand-dark/60 rounded-xl border border-amber-500/10" data-id="element-47">
                <div data-id="element-48">
                  <p className="text-brand-lightGray text-xs" data-id="element-49">
                    Valor real de este bono:
                  </p>
                  <p className="text-brand-lightGray line-through text-base" data-id="element-50">
                    $15 USD
                  </p>
                </div>
                <div className="text-right" data-id="element-51">
                  <p className="text-amber-400 text-xs font-bold" data-id="element-52">HOY:</p>
                  <p className="text-2xl font-serif font-bold text-amber-400" data-id="element-53">
                    GRATIS
                  </p>
                </div>
              </div>

              <div className="mt-4 flex items-center gap-2 text-brand-lightGray/70 text-xs" data-id="element-54">
                <Check className="w-4 h-4 text-green-500" data-id="element-55" />
                <span data-id="element-56">Incluido automáticamente con tu compra</span>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}